document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.featured-collection-carousel__slider');
  sliders.forEach(slider => {
    const container = slider.querySelector('.featured-collection-carousel__product-grid');
    const btnPrev = slider.querySelector('.slider-button--prev');
    const btnNext = slider.querySelector('.slider-button--next');
    const scrollAmount = 300;

    btnPrev?.addEventListener('click', () => {
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    btnNext?.addEventListener('click', () => {
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  });
});
